import { render, staticRenderFns } from "./PageSeo.vue?vue&type=template&id=35405604&scoped=true&"
import script from "./PageSeo.vue?vue&type=script&lang=js&"
export * from "./PageSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35405604",
  null
  
)

export default component.exports